<app-handler-items
    (listItemComplete)="saveOutput($event)"
    (comboItemLength)="itemLenght($event)"
    [itemsData]="resourcesRequest"
    [workOrderData]="workOrder"
    [titleDialog]="'Salida'"
    [addCurrentAmount]="true"
    [replyRoute]="'almacen/salidas_inventario'"
    [urlItemCombo]="urlGetItemsForOutputs"
    [fromPackOff]="fromPackOff"
    [comboWorkOrder]="true"
    [workOrderState]="workOrderState"
    [source]="HandlerItemsSource.OUTPUTS">
</app-handler-items>
